













































































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { MappedProduct, useProducts } from '@/features/products';
import { usePagination } from '@/features/pagination';
import { load } from '@/directives/loading';
import { useAddJumpstartCartItem, useJumpstartCartState } from '@/features/jumpstart';

// components
import { ValidationObserver } from 'vee-validate';
import TextInput from '@/components/TextInput.vue';
import RadioInput from '@/components/RadioInput.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import AppButton from '@/components/AppButton.vue';
import Spinner from '@/components/Spinner.vue';

export default defineComponent({
  name: 'JumpstartChooseBattery',
  components: {
    ValidationObserver,
    TextInput,
    RadioInput,
    SvgIcon,
    AppButton,
    Spinner,
  },
  directives: {
    load,
  },
  setup() {
    const search = ref('');
    const selectedBattery = ref('');
    const batteries = ref<MappedProduct[]>([]);
    const isProductInCart = ref(false);

    // batteries filter variables
    const variables = computed(() => {
      return {
        page: currentPage.value,
        pageSize: pageSize.value,
        search: search.value,
        filter: {
          category_uid: {
            // Batteries category id number
            eq: btoa('4'),
          },
        },
      };
    });

    const { goToPage, currentPage, totalPages, pageSize, updatePageInfo } = usePagination({ pageSize: 6 });
    const { products, fetchProducts, pageInfo, isFetchingProducts } = useProducts(variables);
    const { products: jumpstartProducts } = useJumpstartCartState();
    const { addItem, isAdding } = useAddJumpstartCartItem();

    /**
     * Watches changes in the jumpstartProducts array and updates
     * dependent variables accordingly.
     */
    watch(jumpstartProducts, value => {
      isProductInCart.value = !!value.length;
      selectedBattery.value = value?.length && value[0]?.sku ? value[0].sku : '';
    });

    watch(pageInfo, value => {
      updatePageInfo(value);
    });

    watch(products, value => {
      if (!value?.length) return;
      batteries.value = [...batteries.value, ...value];
    });

    watch(selectedBattery, async value => {
      if (!value) return;
      await addItem(value);
    });

    // On update date when paginate
    function onLoadMore() {
      goToPage(++currentPage.value);
      fetchProducts();
    }

    // Product is out of stock
    function isOutOfStock(value: MappedProduct) {
      return !value?.labels.inStock || !value?.stock;
    }

    // On search battery
    const onSubmit = () => {
      batteries.value = [];
      goToPage(1);
      fetchProducts();
    };

    return {
      onSubmit,
      search,
      selectedBattery,
      batteries,
      totalPages,
      onLoadMore,
      isProductInCart,
      isFetchingProducts,
      currentPage,
      addItem,
      isAdding,
      isOutOfStock,
    };
  },
});
